import LightbulbOutlineIcon from '../../../static_assets/icons/light-bulb-icon.svg';
import CTAIcon from '../../../static_assets/icons/cta-block-icon.svg';

export const testAttributes = {
    RATES_ARTICLES_CONTAINER: 'rates-articles-container',
    RATES_ARTICLES_READING_SECTION: 'rates-articles-reading-section',
    RATES_ARTICLES_NAVIGATION_CONTAINER: 'rates-articles-navigation-container',
    RATES_ARTICLES_FAQ: 'rates-articles-faq',
};

export const navigationIds = {
    HOW_TO_KNOW_MORTGAGE_RATE: 'howToKnowMortgageRate',
    CHOOSING_THE_RIGHT_MORTGAGE: 'choosingRightMortgage',
    CONSISTENT_MONTHLY_PAYMENTS: 'consistentMonthlyPayments',
    REFINANCE_YOUR_MORTGAGE: 'refinanceMortgage',
    REASONS_TO_REFINANCE: 'reasonsToRefinance',
    SHOULD_REFINANCE_NOW: 'shouldYouRefinanceNow',
    STEPS_TO_REFINANCE: 'stepsToRefinance',
};

export const navigationMenu = {
    headline: 'On This Page',
    articleTitles: [
        { label: 'How To Know What Your Mortgage Rate Will Be', href: `#${navigationIds.HOW_TO_KNOW_MORTGAGE_RATE}`, id: navigationIds.HOW_TO_KNOW_MORTGAGE_RATE },
        { label: 'Choosing The Right Mortgage', href: `#${navigationIds.CHOOSING_THE_RIGHT_MORTGAGE}`, id: navigationIds.CHOOSING_THE_RIGHT_MORTGAGE },
        { label: 'Consistent Monthly Payments', href: `#${navigationIds.CONSISTENT_MONTHLY_PAYMENTS}`, id: navigationIds.CONSISTENT_MONTHLY_PAYMENTS },
        { label: 'Refinance Your Mortgage', href: `#${navigationIds.REFINANCE_YOUR_MORTGAGE}`, id: navigationIds.REFINANCE_YOUR_MORTGAGE },
        { label: 'Reasons To Refinance', href: `#${navigationIds.REASONS_TO_REFINANCE}`, id: navigationIds.REASONS_TO_REFINANCE },
        { label: 'Should You Refinance Now?', href: `#${navigationIds.SHOULD_REFINANCE_NOW}`, id: navigationIds.SHOULD_REFINANCE_NOW },
        { label: 'Steps To Refinance', href: `#${navigationIds.STEPS_TO_REFINANCE}`, id: navigationIds.STEPS_TO_REFINANCE },
    ],
}

export const defaultContent = {
    ctaData: {
        title: 'Ready To Buy A Home?',
        description: 'Connect with a lender that will work with your unique financial situation, or use our calculators to estimate how much home you could afford.',
        buttonText: 'Match With Providers',
        icon: CTAIcon,
        articleId: 'rates-article-cta',
        type: 'new',
        headline: '',
        buttons: [
            {
                buttonText: 'Match With Providers',
                href: 'https://mortgage.quickenloans.com/?sourceid=qlwebsite_mortgage-rates-buy&_gl=1*jpnbzl*_gcl_au*ODYwMDk0OC4xNzQ3MjM5NDUxLjExMzg5NzYwNDEuMTc0NzM1MjU1Mi4xNzQ3MzUyNjk1*FPAU*ODYwMDk0OC4xNzQ3MjM5NDUx',
                attributes: { target: '_blank' },
                key: 'matchWithProviders',
            },
            {
                buttonText: 'Calculate Payment',
                href: '/calculators/mortgage-calculator',
                attributes: { target: '_blank' },
                buttonClasses: 'variant-outlined',
                key: 'calculatePayment',
            },
        ],
    },
    infoBox: {
        title: 'Why Quicken Loans?',
        description: 'Quicken Loans is simplifying the process of choosing the perfect solution for your unique financial needs, and we\'ve made it our mission to empower you with the information you need to make confident decisions.',
        boxIcon: LightbulbOutlineIcon,
    },
    faqData: {
        mainTitle: 'Frequently Asked Questions',
        description: 'Here are answers to some common questions about mortgage rates.',
        items: [
            {
                question: 'What’s a good mortgage rate?',
                answer: 'A good mortgage rate is at or below the current average interest rate for that loan type.',
                id: 'mortgage-faq-1'
            },
            {
                question: 'What determines my mortgage rate?',
                answer: 'The mortgage rate you’re offered is based on market conditions, your credit score, loan amount, down payment, loan type, interest rate type and loan term.',
                id: 'mortgage-faq-2'
            },
            {
                question: 'Can I lock in my mortgage rate?',
                answer: 'You can lock in your interest rate by getting a fixed-rate mortgage. You can also get a rate lock if you’re worried about your interest rate changing between your offer and closing.',
                id: 'mortgage-faq-3'
            }
        ]
    }
};
